import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8a267d4a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-col gap-2 w-full mt-4" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-semibold" }, [
    /*#__PURE__*/ _createTextVNode(" Create "),
    /*#__PURE__*/ _createElementVNode("span", { class: "uppercase" }, "api"),
    /*#__PURE__*/ _createTextVNode(" token ")
], -1));
const _hoisted_3 = { class: "flex gap-4" };
const _hoisted_4 = { class: "flex flex-col flex-none gap-2" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "New token name", -1));
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = {
    key: 0,
    class: "flex flex-col gap-2 grow justify-end"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, " Copy / Paste the below token into your third-party app. This token will not be shown again. ", -1));
const _hoisted_9 = { class: "token text-sm" };
const _hoisted_10 = {
    key: 0,
    class: "flex flex-col gap-4 mt-4"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg" }, [
    /*#__PURE__*/ _createTextVNode(" Manage "),
    /*#__PURE__*/ _createElementVNode("span", { class: "uppercase" }, "api"),
    /*#__PURE__*/ _createTextVNode(" tokens ")
], -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "You may delete any of your existing tokens if they are no longer needed.", -1));
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { key: 1 };
import { ref } from 'vue';
import { useConfirm } from 'primevue/useconfirm';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useDateFns, useFetch } from '@apparatix/composables';
import FormTextGroup from '@apparatix/library/FormTextGroup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateApiToken',
    props: {
        apiTokens: {}
    },
    emits: ["update:token-list"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { destroy, post } = useFetch();
        const { formatDate } = useDateFns();
        const confirm = useConfirm();
        const tokenName = ref('');
        const token = ref();
        const createToken = async () => {
            // eslint-disable-next-line camelcase
            const data = await post('/tokens/create', { token_name: tokenName.value });
            if (data.token) {
                token.value = data.token;
                tokenName.value = '';
                emit('update:token-list');
            }
        };
        const onDeleteTokenClick = (e, id) => {
            confirm.require({
                target: e.currentTarget,
                message: 'Are you sure you want to delete this API token?',
                header: 'Confirm delete',
                accept: () => deleteToken(id),
            });
        };
        const deleteToken = async (id) => {
            await destroy(`/tokens/revoke/${id}`);
            emit('update:token-list');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(FormTextGroup, null, {
                            default: _withCtx(() => [
                                _hoisted_5,
                                _createVNode(_unref(InputText), {
                                    modelValue: tokenName.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tokenName).value = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(Button), {
                                label: "Create API token",
                                disabled: !tokenName.value,
                                onClick: createToken
                            }, null, 8, ["disabled"])
                        ])
                    ]),
                    (!!token.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("code", _hoisted_9, _toDisplayString(token.value), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (props.apiTokens.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _createVNode(_unref(DataTable), {
                            size: "small",
                            value: props.apiTokens
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(Column), {
                                    field: "name",
                                    header: "Name"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), {
                                    field: "created_at",
                                    header: "Created"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.created_at)), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), {
                                    field: "last_used_at",
                                    header: "Last used"
                                }, {
                                    body: _withCtx((slotProps) => [
                                        (slotProps.data.last_used_at)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(formatDate)(slotProps.data.last_used_at)), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_14, "never"))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), null, {
                                    body: _withCtx((slotProps) => [
                                        _createVNode(_unref(Button), {
                                            label: "Delete",
                                            severity: "danger",
                                            size: "small",
                                            outlined: "",
                                            onClick: ($event) => (onDeleteTokenClick($event, slotProps.data.id))
                                        }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["value"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
